<p-confirmDialog [style]="{ width: '300px' }"></p-confirmDialog>

<div class="header-bar">
  <h1>Job Alert Settings</h1>
</div>

<div [hidden]="!editMode">
  <div>
    <form [formGroup]="editForm" (submit)="saveAlertSetting($event)">
      <input type="hidden" name="id" formControlName="id" />

      <div class="no-padding" style="position: relative">
        <div
          *ngIf="tabViewIndex != 2"
          style="
            display: inline-block;
            border-radius: 0 10px 0 9px;
            box-shadow: inset 0 -5px 7px -5px rgba(0, 0, 0, 0.2);
            background-color: #eee;
            position: absolute;
            right: 1px;
            top: 1px;
            font-weight: bold;
            padding: 7px 20px 3px 20px;
            line-height: 24px;
            box-sizing: border-box;
          "
        >
          <span style="display: inline-block; vertical-align: top; margin-right: 5px">
            Enabled
          </span>
          <p-inputSwitch formControlName="enabled" [disabled]="disabledSwitch()"></p-inputSwitch>
        </div>

        <div class="card-padding">
          <p-tabView [(activeIndex)]="tabViewIndex" class="tab-padding no-widget-border">
            <p-tabPanel header="Basic Settings">
              <div class="ui-g card">
                <div class="ui-g-12">
                  <div><label for="settingName" class="setting-title">Setting Name</label></div>
                  <div>
                    <input
                      pInputText
                      formControlName="settingName"
                      id="settingName"
                      size="30"
                      [readOnly]="_defaultSettings || fixedTitle"
                    />
                  </div>
                </div>

                <div class="ui-g-12" *ngIf="_defaultSettings">
                  <div class="setting-title nowrap">
                    Link-Up Job
                    <i
                      class="fa fa-question-circle"
                      tooltipStyleClass="xtooltip"
                      pTooltip="Accept jobs that match an existing job"
                    ></i>
                  </div>
                  <div>
                    <p-inputSwitch formControlName="followOnMovements"></p-inputSwitch>
                  </div>
                </div>

                <div class="ui-g-6" *ngIf="!_defaultSettings">
                  <div class="setting-title">
                    <label for="pickup-location" class="bold-text"
                      >Jobs that <strong>Pickup</strong> close to Postcode
                    </label>
                    <i
                      class="fa fa-question-circle"
                      tooltipStyleClass="xtooltip"
                      pTooltip="Include this location when identifying calculating distance to pickups"
                    ></i>
                  </div>
                  <input
                    pInputText
                    id="pickup-location"
                    formControlName="pickupLocationPostcode"
                    placeholder="Enter postcode"
                  />
                </div>

                <div class="ui-g-6" *ngIf="!_defaultSettings">
                  <div class="setting-title">
                    <label for="pickup-location" class="bold-text"
                      >Jobs that <strong>Dropoff</strong> close to Postcode
                    </label>
                    <i
                      class="fa fa-question-circle"
                      tooltipStyleClass="xtooltip"
                      pTooltip="Include this location when identifying calculating distance to dropoffs"
                    ></i>
                  </div>
                  <input
                    pInputText
                    id="dropoff-location"
                    formControlName="dropoffLocationPostcode"
                    placeholder="Enter postcode"
                  />
                </div>

                <div class="ui-g-12 ui-md-6">
                  <div class="slider">
                    <div class="setting-title">
                      Max Distance from Pickup Location
                      <i
                        class="fa fa-question-circle"
                        tooltipStyleClass="xtooltip"
                        pTooltip="Maximum distance (from your base) to Pickup Location"
                      ></i>
                    </div>
                    <div class="slider-value">{{ f.distanceToPickup }} miles</div>
                    <p-slider
                      formControlName="distanceToPickup"
                      [min]="0"
                      [max]="600"
                      [step]="5"
                    ></p-slider>
                  </div>
                </div>

                <div class="ui-g-12 ui-md-6">
                  <div class="slider">
                    <div class="setting-title">
                      Max Distance from Dropoff Location
                      <i
                        class="fa fa-question-circle"
                        tooltipStyleClass="xtooltip"
                        pTooltip="Maximum distance (from your base) to Dropoff Location"
                      ></i>
                    </div>
                    <div class="slider-value">{{ f.distanceToDropoff }} miles</div>
                    <p-slider
                      formControlName="distanceToDropoff"
                      [min]="0"
                      [max]="600"
                      [step]="5"
                    ></p-slider>
                  </div>
                </div>

                <!--
                <div class="ui-g-12 ui-md-6">
                  <div class="setting-title">Movement Types</div>
                  <div>
                    <p-multiSelect [options]="movementTypeChoices"
                                   formControlName="movementTypesSelected"></p-multiSelect>
                  </div>
                </div>
                -->

                <div class="ui-g-12 ui-lg-6">
                  <div class="setting-title">
                    Minimum Notice Period
                    <i
                      class="fa fa-question-circle"
                      tooltipStyleClass="xtooltip"
                      pTooltip="Time (in hours) needed to be notified before a Job is due to start"
                    ></i>
                  </div>
                  <div>
                    <p-selectButton
                      [options]="noticePeriodHoursChoices"
                      (onChange)="noticePeriodHoursChanged()"
                      formControlName="noticePeriodHours"
                    >
                    </p-selectButton>
                  </div>
                </div>

                <div class="ui-g-12 ui-lg-6" *ngIf="!_defaultSettings" style="z-index: 99">
                  <div class="mb-1 mt-1 bold-text">
                    <div class="setting-title">
                      Between dates
                      <i
                        class="fa fa-question-circle"
                        tooltipStyleClass="xtooltip"
                        pTooltip="This Job Notification setting will only be valid between these dates"
                      ></i>
                    </div>
                    <div>
                      <p-calendar formControlName="dateFrom" dateFormat="dd/mm/yy"></p-calendar>
                      and
                      <p-calendar formControlName="dateTo" dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                  </div>
                </div>
              </div>
            </p-tabPanel>
            <p-tabPanel header="Advanced Settings">
              <div class="ui-g card">
                <div class="ui-g-12 ui-lg-6">
                  <div class="setting-title">Days of the week</div>
                  <div>
                    <p-selectButton
                      [options]="weekDayChoices"
                      formControlName="weekDays"
                      [styleClass]="'tickable'"
                      multiple="multiple"
                    >
                    </p-selectButton>
                  </div>
                </div>

                <div class="ui-g-12 ui-lg-6">
                  <div class="slider">
                    <div class="slider-value setting-title">
                      Working Hours:
                      <i
                        class="fa fa-question-circle"
                        tooltipStyleClass="xtooltip"
                        pTooltip="Be notified when Pickup/Dropoff times are in this range"
                      ></i>

                      {{ f.timeRange != null && f.timeRange[0] }}:00 -
                      {{ f.timeRange && f.timeRange[1] }}:00
                    </div>
                    <div style="padding: 0 10px">
                      <p-slider
                        formControlName="timeRange"
                        [range]="true"
                        [min]="0"
                        [max]="23"
                        [step]="1"
                      ></p-slider>
                    </div>
                  </div>
                </div>

                <div class="ui-lg-3">
                  <div class="setting-title">Collection Times</div>
                  <div>
                    <p-selectButton
                      [options]="amPmChoices"
                      formControlName="collectionAMPM"
                      [styleClass]="'tickable'"
                      multiple="multiple"
                    ></p-selectButton>
                  </div>
                </div>

                <div class="ui-lg-3">
                  <div class="setting-title">Delivery Times</div>
                  <div>
                    <p-selectButton
                      [options]="amPmChoices"
                      [styleClass]="'tickable'"
                      formControlName="deliveryAMPM"
                      multiple="multiple"
                    ></p-selectButton>
                  </div>
                </div>

                <div class="ui-g-12 ui-lg-6">
                  <div class="setting-title">Fuel Type</div>
                  <p-selectButton
                    [options]="fuelTypeChoices"
                    formControlName="fuelTypeList"
                    [styleClass]="'tickable'"
                    multiple="multiple"
                  >
                  </p-selectButton>
                </div>

                <div class="ui-g-12" *ngIf="_defaultSettings">
                  <div class="pr-2">
                    <div class="setting-title nowrap">
                      Return Journey To Home
                      <i
                        class="fa fa-question-circle"
                        tooltipStyleClass="xtooltip"
                        pTooltip="Will accept additional Jobs the same day that end closer to their starting location"
                      ></i>
                    </div>
                    <div>
                      <p-inputSwitch formControlName="returnJourneyMovements"></p-inputSwitch>
                    </div>
                  </div>
                </div>
                <div class="ui-g-12 ui-lg-6">
                  <div class="slider">
                    <div class="slider-value setting-title">
                      Notification Hours:
                      <i
                        class="fa fa-question-circle"
                        tooltipStyleClass="xtooltip"
                        pTooltip="Only send me Alert messages between these hours"
                      ></i>

                      {{ f.alertTimeRange != null && f.alertTimeRange[0] }}:00 -
                      {{ f.alertTimeRange && f.alertTimeRange[1] }}:00
                    </div>
                    <div style="padding: 0 10px">
                      <p-slider
                        formControlName="alertTimeRange"
                        [range]="true"
                        [min]="0"
                        [max]="24"
                        [step]="1"
                      ></p-slider>
                    </div>
                  </div>
                </div>
              </div>
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>

      <div class="fixed-bottom" *ngIf="tabViewIndex != 2">
        <button
          *ngIf="_canDelete && f.id > 0"
          pButton
          type="button"
          (click)="deleteSelected(f.id)"
          label="Delete Settings"
          class="ui-button ui-button-danger"
        ></button>
        <button
          *ngIf="_canDelete"
          pButton
          type="button"
          label="Cancel"
          class="ui-button"
          (click)="editMode = false"
        ></button>
        <button
          pButton
          type="submit"
          label="Save Settings"
          class="ui-button ui-button-primary"
          style="margin-right: 15px"
          [disabled]="editForm.invalid"
        ></button>
      </div>
    </form>
  </div>
</div>
